// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderLink--link--XnUti","link__icon":"HeaderLink--link__icon--19vgO"};